import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { WireSculpture } from './WireSculpture';
import { poles } from '../../../data/poles';
import { pad2 } from '../../../utils/format';
const formats = ['STEP', 'OBJ', 'STL', 'DWG', 'PDF'];
export function Workshop() {
  const [active, setActive] = useState(0);
  const pole = poles[active];
  return <section aria-labelledby="workshop-title" className="bg-night py-24 text-white md:py-32" data-id="element-252" data-mp="188g3pj2t48bp">
      <div className="shell" data-id="element-253" data-mp="1c9t6tleilxex">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-end" data-id="element-254" data-mp="1cauls0ynj41x">
          <div className="lg:col-span-7" data-id="element-255" data-mp="ya0e5kjfh74b">
            <h2 id="workshop-title" className="text-[clamp(36px,5vw,72px)] font-medium leading-[0.98] tracking-[-0.04em]" data-id="element-256" data-mp="ybbpc5f7dh5g">
              Du fichier STEP
              <br data-id="element-257" data-mp="2sp2twqiodau1" />
              à la pièce de 14 mètres.
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/65" data-id="element-258" data-mp="2xnnw2vhhm4l4">
              Cinq pôles de fabrication sous un même toit. Notre bureau d’études intervient dès l’amont —
              modélisation, découpage en modules, plans d’exécution — pour que la pièce livrée soit exactement celle
              que vous avez imaginée.
            </p>
          </div>
          <figure className="relative overflow-hidden lg:col-span-5" data-id="element-259" data-mp="3slgw54zhz990">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/f7f22bf1-b285-4c32-82ed-0de76e5d1f6b.jpg" alt="Poste du bureau d’études affichant un modèle 3D filaire de sculpture" className="aspect-[3/2] w-full object-cover" data-id="element-260" data-mp="3oiu8zhdruci5" />
            <figcaption className="absolute inset-x-0 bottom-0 flex flex-wrap items-center gap-1.5 bg-night/75 p-3 backdrop-blur-sm" data-id="element-261" data-mp="39upms3fifium">
              <span className="mr-2 text-xs text-white/60" data-id="element-262" data-mp="p2xailbbr1n6">Formats acceptés</span>
              {formats.map(f => <span key={f} className="border border-white/15 px-2 py-0.5 font-mono text-[11px] text-white/90" data-id="element-263" data-mp="k4caalw2ohyq">
                  {f}
                </span>)}
            </figcaption>
          </figure>
        </div>

        <div className="mt-20 grid gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-264" data-mp="3itkewvvuemdc">
          <div className="relative h-[380px] self-start border border-white/10 bg-night-soft md:h-[540px] lg:sticky lg:top-[104px]" data-id="element-265" data-mp="3mvz2tuedccbh">
            <WireSculpture active={active} data-id="element-266" data-mp="3rv1v0e992o21" />
            <div className="pointer-events-none absolute inset-x-0 top-0 flex items-start justify-between gap-4 p-4 font-mono text-[11px] text-white/55 md:p-5" data-id="element-267" data-mp="2v5axe65nwks0">
              <AnimatePresence mode="wait" initial={false} data-id="element-268" data-mp="2z760ng75l88f">
                <motion.div key={pole.id} initial={{
                opacity: 0,
                y: 4
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -4
              }} transition={{
                duration: 0.16,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-269" data-mp="345r0heihtpwc">
                  <p data-id="element-270" data-mp="2gfmwv75b1q5c">
                    <span className="text-ember" data-id="element-271" data-mp="2gf3ooi5gig4i">Pôle {pad2(active + 1)}</span> / {pad2(poles.length)}
                  </p>
                  <p className="mt-1 font-sans text-base font-medium text-white" data-id="element-272" data-mp="28ut5enro80zb">{pole.name}</p>
                </motion.div>
              </AnimatePresence>
              <p className="hidden truncate text-right sm:block" data-id="element-273" data-mp="1yxy5q1jnvujg">{pole.file}</p>
            </div>
            <p className="pointer-events-none absolute bottom-4 left-4 font-mono text-[11px] text-white/40 md:bottom-5 md:left-5" data-id="element-274" data-mp="1uxw4fthu934p">
              Survolez pour orienter le modèle
            </p>
          </div>

          <ol data-id="element-275" data-mp="1l69vy4wvxi5n">
            {poles.map((p, i) => {
            const isActive = i === active;
            return <motion.li key={p.id} onViewportEnter={() => setActive(i)} viewport={{
              margin: '-45% 0px -45% 0px'
            }} onMouseEnter={() => setActive(i)} className="border-t border-white/10 py-8 last:border-b md:py-10" data-id="element-276" data-mp="1g8hv2le9ilpb" data-mpi={i}>
                  <div className="flex items-baseline gap-5" data-id="element-277" data-mp="12atcjk7o3qnf">
                    <span className={`font-mono text-sm transition-colors duration-200 ${isActive ? 'text-ember' : 'text-white/35'}`} data-id="element-278" data-mp="32b8ayk581dey">
                      {pad2(i + 1)}
                    </span>
                    <div className="flex-1" data-id="element-279" data-mp="2xiow7jussc8k">
                      <h3 className={`text-2xl font-medium tracking-[-0.03em] transition-colors duration-200 md:text-[32px] ${isActive ? 'text-white' : 'text-white/45'}`} data-id="element-280" data-mp="2xhnc6pvt0fep">
                        {p.name}
                      </h3>
                      <p className="mt-3 max-w-lg leading-relaxed text-white/60" data-id="element-281" data-mp="2ekcakymp99w3">{p.description}</p>
                      <ul className="mt-4 flex flex-wrap gap-2" data-id="element-282" data-mp="7ueh57eue6rf">
                        {p.machines.map(m => <li key={m} className="bg-white/[0.06] px-2.5 py-1 text-sm text-white/80" data-id="element-283" data-mp="csg07sc9q62w">
                            {m}
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </motion.li>;
          })}
          </ol>
        </div>
      </div>
    </section>;
}